// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es6.object.is-extensible.js
// module id = ../../node_modules/core-js/modules/es6.object.is-extensible.js
// module chunks = 18